import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31673794"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "root",
  class: "CustomCursor z-cursor"
}
const _hoisted_2 = { class: "Cursor" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "Border",
  fill: "none",
  viewBox: "0 0 200 200"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "100",
    cy: "100",
    r: "95.3125",
    stroke: "var(--white)",
    "stroke-width": "9.375"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "100",
    cy: "100",
    r: "95.3125",
    stroke: "url(#UIBtnCamera-gradient)",
    "stroke-width": "9.375"
  }),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("linearGradient", {
      id: "UIBtnCamera-gradient",
      x1: "32.62",
      x2: "233.51",
      y1: "-58.83",
      y2: "21.69",
      gradientUnits: "userSpaceOnUse"
    }, [
      /*#__PURE__*/_createElementVNode("stop", { "stop-color": "#F5AAE0" }),
      /*#__PURE__*/_createElementVNode("stop", {
        offset: ".48",
        "stop-color": "#A47CDA",
        "stop-opacity": ".82"
      }),
      /*#__PURE__*/_createElementVNode("stop", {
        offset: "1",
        "stop-color": "#4D4BD2",
        "stop-opacity": ".63"
      })
    ])
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Background" }, null, -1))
const _hoisted_5 = {
  class: "Label small-caps",
  ref: "label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, {
    onEnter: _ctx.onEnter,
    onLeave: _ctx.onLeave
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("span", _hoisted_5, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ], 512)
        ])
      ], 512), [
        [_vShow, _ctx.show]
      ])
    ]),
    _: 3
  }, 8, ["onEnter", "onLeave"]))
}